<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="日期:">
          <el-date-picker
            v-model="value1"
            type="monthrange"
            range-separator="至"
            value-format="yyyy-MM"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker> </el-form-item
        ><br />
        <el-form-item v-if="!display_game" label="所属游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!display_channel" label="所属渠道:">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道包组:">
          <el-select
            v-model="searchValue.group_channel_ids"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelGroupSelectList"
              :key="item.id"
              :label="item.group_name"
              :value="item.group_channel_ids"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchRechargeList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportMonthSummary()"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column prop="monDate" label="日期" width="100" fixed> </el-table-column>
      <el-table-column prop="monthReg" label="总新增"> </el-table-column>
      <el-table-column label="总新增环比">
        <template slot-scope="scope">{{ scope.row.regLinkRatio }}%</template>
      </el-table-column>
      <el-table-column prop="monthFirstMoney" label="总新增充值">
      </el-table-column>
      <el-table-column label="总新增充值环比">
        <template slot-scope="scope">{{ scope.row.firMLinkRatio }}%</template>
      </el-table-column>
      <el-table-column prop="monthMoney" label="总充值"> </el-table-column>
      <el-table-column label="总充值环比">
        <template slot-scope="scope"
          >{{ scope.row.monMregLinkRatio }}%</template
        >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
import moment from "moment";
export default {
  name: "monthSummary",
  components: {},
  data() {
    return {
      loadingData: false,
      searchValue: {
        game_id: "",
        channel_id: [],
        created_from: "",
        created_to: "",
        group_channel_ids: "",
      },
      value1: [],
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      gamesList: [],
      channelSelectList: [],
      channelSelectAllList: [],
      channelGroupSelectList: [],
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
      },
      collect: [],
    };
  },
  computed: {
    ...mapState(["host"]),
    display_channel () {
      return window.displayChannel
    },
    display_game () {
      return window.displayGame
    },
  },
  created() {
    this.addDate();

    let date = moment().startOf("year"); //第一个月
    let y = date.get("year");
    let m = date.get("month") + 1;
    let dateStart = y + "-" + m;

    this.value1[0] = dateStart;
    this.value1[1] = this.systemTime;

    this.searchValue.created_from = this.value1[0];
    this.searchValue.created_to = this.value1[1];
    this.getGameSelectList();
    this.getChannelSelect();
    this.channelGroupSelect();
    this.getRechargeList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRechargeList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRechargeList(false);
    },

    // 导出
    exportMonthSummary() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/statistics/month_summary", params);
    },
    // 获取游戏选择列表数据
    getGameSelectList(row) {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },
    // 获取渠道选择列表数据
    getChannelSelect(row) {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelSelectAllList = res.data.data;
        this.channelSelectList = res.data.data;
      });
    },
    // 渠道包组 下拉选择列表
    channelGroupSelect() {
      fetch({
        url: "/admin/channel_package_group/select",
        method: "GET",
      }).then((res) => {
        this.channelGroupSelectList = res.data.data;
      });
    },

    // 根据所属游戏,显示对应的所属渠道
    selectChannel(vid) {
      let obj = {};
      obj = this.gamesList.find((item) => {
        return item.id == vid;
      });
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (obj) {
          if (item.game_id == obj.id) {
            this.channelSelectList.push(item);
          }
        } else {
          this.channelSelectList.push(item);
        }
      });
    },
    // 实现渠道包数据的搜索
    searchRechargeList() {
      this.searchValue.created_from = this.value1[0];
      this.searchValue.created_to = this.value1[1];
      this.currentPage = 1;
      this.getRechargeList(true);
    },
    addDate() {
      let date1 = moment().endOf("year"); //最后一个月
      let yy = date1.get("year");
      let mm = date1.get("month") + 1;

      this.systemTime = yy + "-" + mm;
    },
    // 展示用户角色列表数据
    getRechargeList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      let channel_id = this.searchValue.channel_id.toString();
      fetch({
        url: "/admin/statistics/month_summary",
        method: "GET",
        params: {
          ...searchValue,
          channel_id: channel_id,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            const { list, collect } = res.data.data
            this.tableData = list.data
            this.collect = collect
            this.totalRecords = list.total
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    // 数据统计
    getSummaries({ columns }) {
      let arr = [];
      const keyList = {
        'monthReg': 'monthReg',
        'monthFirstMoney': 'monthFirstMoney',
        'monthMoney': 'monthMoney',
      }
      columns.forEach(item => {
        let result = ''
        const property = item?.property
        const target = property && keyList[property]
        if (target) {
          result = this.collect[target]
          if (property.indexOf('rate') !== -1) result += '%'
        }
        arr.push(result)
      })
      arr.splice(0, 1, "合计")
      return arr;
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
</style>
